const state = {
	id: null,
	role: null,
	firstname: null,
	lastname: null,
	email: null,
	picture: null,
	token: null,
	refresh: null,
	token_duration: null,
	phone: null,
	address: {
		line: null,
		zip: null,
		city: null,
		country: null
	},
	clients: [],
	available: null,
	investment_stats: null
}

export default state



// WEBPACK FOOTER //
// ./src/store/modules/Users/state.js